<template>
  <div
    class="other-materials"
    :class="
      item.theme ? 'other-materials_' + item.theme : 'other-materials_dark'
    "
    @click="
      blockClick(
        item.title,
        helpers.buildRoute(
          item.route || {
            name: 'SuccessAcademySections',
            params: { slug: item.slug },
          }
        )
      )
    "
  >
    <div class="other-materials__generate _pa-8">
      <div class="other-materials__text">
        <h3
          class="other-materials__title _fs-20 _lh-24 _fw-700"
          v-html="item.title"
        ></h3>
        <div
          class="other-materials__descr _fs-16 _lh-24 _mt-2"
          v-html="item.descr"
        ></div>
      </div>
      <!-- <picture>
        <source
          v-for="(src, i) in item.images"
          :srcset="src.src"
          :key="i"
          :media="src.media"
        /> -->
      <img class="other-materials__img" :src="item.image" />
      <!-- </picture> -->
    </div>
  </div>
</template>

<script>
import toPage from '@/mixins/toPage'
export default {
  name: 'OtherMaterials',
  props: {
    item: Object,
    analyticEventPrefix: String,
  },
  mixins: [toPage],
  methods: {
    blockClick(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: this.analyticEventPrefix + 'other_sections',
          param_value: this.helpers.stripHtml(txt),
        })
      }

      this.toPage(path)
    },
  },
}
</script>

<style lang="scss" scoped>
.other-materials {
  &__generate {
    position: relative;
    border-radius: 16px;
    height: 320px;
    overflow: hidden;
    border: 1px solid color(light-grey);
    background-color: color(green-light);
    background-image: linear-gradient(
      176.15deg,
      #e9eef1 38.14%,
      rgba(235, 242, 237, 0) 48.11%
    );
    cursor: pointer;
    @media screen and (max-width: 1024px) {
      width: 280px;
    }
  }
  &__text {
    max-width: 200px;
    position: absolute;
    z-index: 2;
  }
  &__img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    object-position: top;
    z-index: 1;
  }

  &_dark {
    .other-materials {
      &__title {
        color: color(dark);
      }

      &__descr {
        color: color(dark-grey);
      }
    }
  }

  &_light {
    .other-materials {
      &__title {
        color: color(white);
      }

      &__descr {
        color: color(white);
      }
    }
  }
}
</style>
